import { ICon } from '@interfaces';

const BookRequestIcon = (props: ICon) => {
  const { onClick, width = 20, height = 20, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 20"
      role="img"
      onClick={onClick}
      className={className}
      {...props}
    >
      <path d="M20 5.03h-7V0H1.23A1.237 1.237 0 0 0 0 1.239v17.527a1.23 1.23 0 0 0 1.23 1.23H13v-5.35h7ZM1.4 1.4h1.9v17.2H1.4Zm10.2 17.2H4.7V1.4h6.9v3.63H8v12l2.75-2.38h.85Zm7-5.35h-8.38l-.82.72V6.43h9.2Z" />
      <path d="M10.3 7.76h7.39v1.4H10.3zm0 2.709h7.39v1.4H10.3z" />
    </svg>
  );
};

const HeartIcon = (props: ICon) => {
  const { onClick, width = 20, height = 20, className, fill } = props;
  // @ts-ignore
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 18.318"
      role="img"
      onClick={onClick}
      className={className}
      {...props}
    >
      <g
        style={{
          fill: 'none',
          strokeMiterlimit: 10,
        }}
      >
        <path
          d="M582.71 148.659a5.972 5.972 0 0 0-8.246-.182 5.977 5.977 0 0 0-8.247 8.649l8.008 8.007a.336.336 0 0 0 .476 0l8.008-8.007a5.988 5.988 0 0 0 .001-8.467Z"
          style={{
            stroke: 'none',
          }}
          transform="translate(-564.464 -146.915)"
        />
        <path
          d="M570.426 148.315a4.521 4.521 0 0 0-3.219 1.335 4.555 4.555 0 0 0-1.343 3.243 4.56 4.56 0 0 0 1.343 3.244l7.257 7.255 7.256-7.255a4.558 4.558 0 0 0 1.344-3.244 4.556 4.556 0 0 0-1.344-3.244 4.52 4.52 0 0 0-3.218-1.334 4.595 4.595 0 0 0-3.096 1.199l-.942.855-.941-.855a4.596 4.596 0 0 0-3.097-1.199m0-1.4c1.446 0 2.894.523 4.038 1.563a5.993 5.993 0 0 1 4.038-1.563c1.523 0 3.044.58 4.208 1.744a5.988 5.988 0 0 1 0 8.468l-8.008 8.007a.33.33 0 0 1-.238.099.331.331 0 0 1-.238-.099l-8.009-8.007a5.988 5.988 0 0 1 0-8.468 5.927 5.927 0 0 1 4.209-1.744Z"
          style={{
            fill: fill || '#303030',
            stroke: 'none',
          }}
          transform="translate(-564.464 -146.915)"
        />
      </g>
    </svg>
  );
};
const WishListIcon = (props: ICon) => {
  const { onClick, width = 20, height = 20, className, fill = '#D42A1C' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
      {...props}
    >
      <path
        d="M14.0376 3.24381C13.6987 2.86348 13.2852 2.55683 12.8229 2.34288C12.3606 2.12893 11.8593 2.01225 11.3501 2.00006C10.8412 1.98891 10.3354 2.08059 9.86287 2.2696C9.39033 2.45862 8.96081 2.74108 8.60005 3.10006L8.00005 3.69381L7.5313 3.23131C6.07505 1.76881 3.70005 1.64381 2.2438 2.96256C1.86482 3.30254 1.55916 3.71626 1.34553 4.1784C1.13189 4.64054 1.01476 5.14141 1.00131 5.65036C0.987852 6.15932 1.07835 6.66567 1.26727 7.13846C1.45619 7.61125 1.73956 8.04053 2.10005 8.40006L7.2938 13.5938C7.38621 13.6872 7.4962 13.7613 7.61743 13.8118C7.73865 13.8624 7.8687 13.8885 8.00005 13.8885C8.1314 13.8885 8.26145 13.8624 8.38268 13.8118C8.5039 13.7613 8.6139 13.6872 8.7063 13.5938L13.7688 8.53131C15.2313 7.07506 15.3501 4.70006 14.0376 3.24381Z"
        fill={fill}
      />
    </svg>
  );
};

const CartIcon = (props: ICon) => {
  const { onClick, width = 20, height = 20, className, fill = '#303030' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20 19"
      role="img"
      onClick={onClick}
      className={className}
      {...props}
    >
      <path
        d="M19.411 3.115H5.155L4.461 0H.719a.742.742 0 0 0 0 1.484h2.6l2.128 9.565a1.888 1.888 0 0 0 .394 3.718h1.948a2.056 2.056 0 1 0 .052 0h7.139a2.055 2.055 0 1 0 .051 0h2.336a.742.742 0 0 0 0-1.484H5.838a.4.4 0 0 1 0-.8h11.886a.594.594 0 0 0 .576-.48l1.687-8.159a.6.6 0 0 0-.576-.729ZM8.43 16.882a.617.617 0 1 1-.616-.635.627.627 0 0 1 .616.635Zm7.19 0a.617.617 0 1 1-.616-.635.626.626 0 0 1 .616.635Zm1.418-5.88H6.907l-1.4-6.405h12.859Z"
        fill={fill}
      />
    </svg>
  );
};

const UserIcon = (props: ICon) => {
  const { onClick, width = 20, height = 20, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/ 2000/svg"
      width={width}
      height={height}
      viewBox="0 0 512 512"
      role="img"
      onClick={onClick}
      className={className}
    >
      <path d="M245.5 5.6c-29.3 3.2-54.4 14.7-74.9 34.3-25.1 24.1-37.9 54.2-37.9 89.1 0 26.6 6.1 47.1 20.7 68.9 18.1 27.1 48.5 47 80.1 52.4l8 1.3-8.5.8c-103.7 9.2-190.6 76.1-218.4 167.9-7 23-10.7 54.6-9 75.7l.9 10.5 248.9.3c169 .1 249.3-.1 250-.8 1.5-1.5 1.2-39.5-.3-50-3.5-24.7-9.9-45.7-20.6-67.5-11.7-23.9-24-41.3-43.3-60.9-42.1-42.8-100.4-69.8-162.2-75.2l-8.5-.7 7.5-1.3c31.1-5.4 62.2-25.5 80-52 33.9-50.1 27.4-115.3-15.7-157.6-17.8-17.4-39.2-28.7-63.3-33.2-8.5-1.6-26.7-2.7-33.5-2zM266 38c42.4 5.1 75.7 38.3 81.1 80.8 5.5 44.1-24.4 87.8-67.7 98.7-18.7 4.8-34.6 4.2-52.7-1.9-13.8-4.7-24.3-11.3-35.1-22.2-22.7-22.6-31.9-53.7-25-84.4 8.4-37.4 40.4-66.5 77.8-70.9 10.2-1.2 12.2-1.2 21.6-.1zm28.9 249c25.1 4.4 45.7 11.2 67.5 22.3C419 338 458.8 388 470.9 445.5c2.1 10.1 4.2 27.4 3.4 28.7-.2.5-98.5.8-218.3.8s-218.1-.3-218.3-.8c-.9-1.5 1.5-20.1 3.9-31.1 16.1-72.3 76.5-131.4 154.9-151.6 11.2-2.9 24.7-5.3 37.5-6.9 1.9-.2 13.6-.3 26-.1 17.7.2 25.1.7 34.9 2.5z" />
    </svg>
  );
};

const UserCircleIcon = (props: ICon) => {
  const { onClick, width = 20, height = 20, fill = '#303030' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 15 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      {...props}
    >
      <path d="M5 5.5a2.5 2.5 0 1 1 5 0 2.5 2.5 0 0 1-5 0Z" fill={fill} />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.5 0a7.5 7.5 0 1 0 0 15 7.5 7.5 0 0 0 0-15ZM1 7.5a6.5 6.5 0 1 1 10.988 4.702A3.5 3.5 0 0 0 8.5 9h-2a3.5 3.5 0 0 0-3.488 3.202A6.482 6.482 0 0 1 1 7.5Z"
        fill={fill}
      />
    </svg>
  );
};

const SubscriptionIcon = (props: ICon) => {
  const { onClick, className } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="13.758"
      viewBox="0 0 24 13.758"
      onClick={onClick}
      className={className}
      {...props}
    >
      <path
        d="M22.3,4.678v-.34a.352.352,0,1,0-.7,0v.34a.352.352,0,1,0,.7,0Zm-4.8-.34v.34a.352.352,0,0,0,.7,0v-.34a.352.352,0,0,0-.7,0Zm2.678.125a.365.365,0,0,1-.551,0,.352.352,0,0,0-.53.462,1.068,1.068,0,0,0,1.611,0,.352.352,0,0,0-.53-.462Zm3.782.289a4.1,4.1,0,0,0-7.5-1.639A8.528,8.528,0,0,0,12.756.5a.349.349,0,0,0-.113-.04A8.479,8.479,0,0,0,4.121,2.254a.352.352,0,0,0,.477.516A7.8,7.8,0,0,1,6.1,1.685l1,1.737L5.242,6.3H2.406A7.722,7.722,0,0,1,3.539,3.972a.352.352,0,1,0-.572-.409A8.414,8.414,0,0,0,1.674,6.31a1.709,1.709,0,0,0-1.387.972A1.1,1.1,0,0,0,.644,8.643a2.857,2.857,0,0,0-.54.424.352.352,0,0,0,.5.5,2.106,2.106,0,0,1,1.027-.569l.54.916c.041.069.084.137.13.2a1.6,1.6,0,0,0-.094.638l.021.385c.01.186.015.375.015.561v1.13a.931.931,0,0,0,.93.93H6.01a.931.931,0,0,0,.93-.93v-.277a4.577,4.577,0,0,0-.074-.816l0-.01c-.008-.044-.017-.089-.026-.133H9.81c0,.036,0,.071,0,.107v1.13a.931.931,0,0,0,.93.93h2.839a.931.931,0,0,0,.93-.93v-.277a4.574,4.574,0,0,0-.074-.818v-.007c-.008-.045-.017-.09-.027-.134h.252a3.373,3.373,0,0,0,.472-.034c0,.047,0,.094,0,.14v1.13a.931.931,0,0,0,.93.93H18.9a.931.931,0,0,0,.93-.93v-.277a4.572,4.572,0,0,0-.074-.818v-.008a4.583,4.583,0,0,0-.548-1.482l-.1-.169h.237a4.644,4.644,0,0,0,1.6-.281.352.352,0,0,0-.241-.66,3.941,3.941,0,0,1-1.356.238H13.7a.949.949,0,0,1-.932-1.129A1.906,1.906,0,0,1,14.641,6.7h.265a1.468,1.468,0,0,0,1.426-1.114L16.6,4.52a3.409,3.409,0,0,1,.217-.611l.007-.016a3.4,3.4,0,0,1,6.433.959,3.951,3.951,0,0,1-1.234,3.477.351.351,0,1,0,.476.517,4.654,4.654,0,0,0,1.453-4.1ZM6.726,1.37a7.774,7.774,0,0,1,5.332-.355L10.865,3.081H7.713ZM7.7,3.784h3.174L12.5,6.3H6.079ZM4.55,12.822v.233H3.171a.227.227,0,0,1-.227-.227V11.7c0-.2-.005-.4-.016-.6l-.021-.385a.9.9,0,0,1,.9-.953H4.7a.907.907,0,0,1,.781.448l.227.389a3.871,3.871,0,0,1,.367.849H5.925A1.376,1.376,0,0,0,4.55,12.822Zm1.687.006a.227.227,0,0,1-.227.227H5.253v-.233a.672.672,0,0,1,.672-.672h.291a3.893,3.893,0,0,1,.021.4ZM7.9,10.889H6.627a4.556,4.556,0,0,0-.311-.645l-.227-.389a1.613,1.613,0,0,0-1.388-.8H3.809a1.59,1.59,0,0,0-1.081.419l-.371-.631H7.9ZM1.28,8.143A.395.395,0,0,1,.923,7.58a1,1,0,0,1,.9-.575H12.584a2.594,2.594,0,0,0-.5,1.1c0,.011,0,.022-.005.033H1.28ZM10.213,9.56a1.592,1.592,0,0,0-.438,1.193l.007.136H8.607V8.846h3.5a1.619,1.619,0,0,0,.072.212h-.8a1.593,1.593,0,0,0-1.167.5Zm8.918,2.991v.277a.227.227,0,0,1-.227.227h-.757v-.233a.673.673,0,0,1,.672-.672h.291a3.842,3.842,0,0,1,.021.4ZM17.5,10.075h.782a.9.9,0,0,1,.1.135l.227.389a3.861,3.861,0,0,1,.367.849h-.151a1.376,1.376,0,0,0-1.375,1.375v.233H16.065a.227.227,0,0,1-.227-.227V11.7c0-.1,0-.21,0-.316A3.427,3.427,0,0,0,17.5,10.075Zm-.9,0a2.72,2.72,0,0,1-1.934.814H14.2a4.556,4.556,0,0,0-.311-.645l-.1-.169ZM13.787,12.15a3.842,3.842,0,0,1,.021.4v.277a.227.227,0,0,1-.227.227h-.757v-.233a.672.672,0,0,1,.672-.672Zm-.734-1.941.227.389a3.861,3.861,0,0,1,.367.849H13.5a1.376,1.376,0,0,0-1.375,1.375v.233h-1.38a.227.227,0,0,1-.227-.227V11.7c0-.2-.005-.4-.016-.6l-.021-.385a.9.9,0,0,1,.9-.953h.892a.907.907,0,0,1,.781.448Zm2.864-5.86-.266,1.067A.766.766,0,0,1,14.907,6h-.265a2.594,2.594,0,0,0-1.221.3h-.085L11.48,3.423l1.256-2.175A7.819,7.819,0,0,1,16.1,3.8a4.146,4.146,0,0,0-.181.554Zm0,0"
        transform="translate(-0.001 0)"
      />
    </svg>
  );
};

const FavoriteIcon = (props: ICon) => {
  const { onClick, width = 18, height = 16, className, color = '#D42A1C', fill } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 16"
      fill={fill ? fill : 'none'}
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="m9.446 14.555 6.328-6.328c1.554-1.563 1.781-4.118.312-5.75a4.063 4.063 0 0 0-5.898-.164L9 3.508 7.977 2.477C6.414.922 3.86.695 2.227 2.164a4.063 4.063 0 0 0-.164 5.899l6.492 6.492a.633.633 0 0 0 .89 0v0Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const StarEmptyIcon = (props: ICon) => {
  const { onClick, width = 20, height = 20, className, color = '#FD7E14' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="m10.344 14.899 3.938 2.5c.508.32 1.133-.157.984-.743l-1.14-4.484a.68.68 0 0 1 .226-.688l3.531-2.945c.461-.383.227-1.156-.375-1.195L12.9 7.047a.648.648 0 0 1-.57-.422l-1.72-4.328a.649.649 0 0 0-1.219 0L7.672 6.625a.648.648 0 0 1-.57.422l-4.61.297c-.6.039-.835.812-.374 1.195l3.531 2.945a.68.68 0 0 1 .227.688L4.82 16.328c-.18.703.57 1.274 1.172.89l3.664-2.32a.64.64 0 0 1 .687 0v0Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const StarFullIcon = (props: ICon) => {
  const { onClick, width = 20, height = 20, className, color = '#FD7E14' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="m10.344 14.899 3.938 2.5c.508.32 1.133-.157.984-.743l-1.14-4.484a.68.68 0 0 1 .226-.688l3.531-2.945c.461-.383.227-1.156-.375-1.195L12.9 7.047a.648.648 0 0 1-.57-.422l-1.72-4.328a.649.649 0 0 0-1.219 0L7.672 6.625a.648.648 0 0 1-.57.422l-4.61.297c-.6.039-.835.812-.374 1.195l3.531 2.945a.68.68 0 0 1 .227.688L4.82 16.328c-.18.703.57 1.274 1.172.89l3.664-2.32a.64.64 0 0 1 .687 0v0Z"
        fill={color}
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const CartPurchaseIcon = (props: ICon) => {
  const { onClick, width = 24, height = 24, className, color = '#fff' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="M17.25 17.25H6.544L3.928 2.869a.75.75 0 0 0-.731-.619H1.5M7.5 21a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Zm9.75 0a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M5.86 13.5h11.774a1.49 1.49 0 0 0 1.472-1.228L20.25 6H4.5"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const StorePurchaseIcon = (props: ICon) => {
  const { onClick, width = 24, height = 24, className, color = '#D42A1C' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="M4.5 13.088V19.5a.75.75 0 0 0 .75.75h13.5a.75.75 0 0 0 .75-.75v-6.412M5.063 3.75h13.875a.76.76 0 0 1 .721.544L21 9H3l1.34-4.706a.76.76 0 0 1 .723-.544v0Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9 9v1.5a3 3 0 0 1-6 0V9m12 0v1.5a3 3 0 0 1-6 0V9m12 0v1.5a3 3 0 0 1-6 0V9"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const BookPurchaseIcon = (props: ICon) => {
  const { onClick, width = 24, height = 24, className, color = '#fff' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="M5 18.75a2.25 2.25 0 0 1 2.25-2.25H19.4"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.25 3H19.4v18H7.25A2.25 2.25 0 0 1 5 18.75V5.25A2.25 2.25 0 0 1 7.25 3v0Z"
        stroke={color}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
const AudioIcon = (props: ICon) => {
  const { width = 26, height = 26, fill = '#fff' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 26 26">
      <g transform="translate(1 1)">
        <g fill="#2a2c34" stroke="#fff" strokeWidth="1">
          <rect width="24" height="24" rx="2" stroke="none" />
          <rect x="-0.5" y="-0.5" width="25" height="25" rx="2.5" fill="none" />
        </g>
        <path
          d="M1160.1,1878.08a8.724,8.724,0,1,0-17.448-.019l-.006,5.652,1.221,0,0,2.164a.87.87,0,0,0,.871.873l1.927,0a.314.314,0,0,0,.316-.314l.007-6.314a.316.316,0,0,0-.315-.316l-1.927,0a.875.875,0,0,0-.873.872l0,1.814h0l0-4.432a7.5,7.5,0,1,1,15.006.016l0,2.617a.876.876,0,0,0-.872-.874h-1.962a.314.314,0,0,0-.315.315l-.007,6.315a.315.315,0,0,0,.315.315l1.962,0a.869.869,0,0,0,.873-.87l0-2.164h1.221Z"
          transform="translate(-1139.374 -1866.073)"
          fill={fill}
        />
      </g>
    </svg>
  );
};
const MyBookIcon = (props: ICon) => {
  const { width = 14, height = 20, fill = '#fff' } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      fill={fill}
      viewBox="0 0 14.839 20.032"
    >
      <defs>
        <style>{'.a{fill:#303030;}'}</style>
      </defs>
      <path
        className="a"
        d="M706.569,655.213a1.289,1.289,0,0,0-1.287-1.287H694.125a2.4,2.4,0,0,0-2.4,2.4v14.622c0,.082.02.159.027.24a3.072,3.072,0,0,0,.041.364l0,.013a3.043,3.043,0,0,0,2.968,2.4v-.027c.1.008.2.027.3.027H706.56v-1.4H695.069a1.826,1.826,0,0,1-1.925-1.5c0-.043-.012-.085-.013-.13a1.8,1.8,0,0,1,1.938-1.6h11.5Zm-1.4,12.714h-8.843v-12.6h8.843Zm-12.039.571V656.322a1,1,0,0,1,.995-1h.8V667.94A3.548,3.548,0,0,0,693.13,668.5Z"
        transform="translate(-691.73 -653.926)"
      />
      <rect className="a" width={11} height={1.4} transform="translate(3.419 16.317)" />
    </svg>
  );
};
const OrderIcon = (props: ICon) => {
  const { width = 14, height = 20 } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 14.732 20">
      <path
        d="M669.963,691.114H666.8V689a3.156,3.156,0,1,0-6.313,0v2.111h-3.151l-1.052,14.732h14.732ZM661.886,689a1.757,1.757,0,0,1,3.514,0v2.109h-3.514Zm-4.1,15.443.853-11.932h10.02l.853,11.932Z"
        transform="translate(-656.283 -685.846)"
      />
      <path
        d="M662.654,699.652l-1.667-1.667-.99.99,2.657,2.657L667.288,697l-.99-.99Z"
        transform="translate(-656.283 -685.846)"
      />
    </svg>
  );
};
const ReviewIcon = (props: ICon) => {
  const { width = 20, height = 17 } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 20.058 17.065"
    >
      <path
        d="M426.662,499.5v10.871H416.334l-.4.361-1.89,1.709v-2.07H409.4V499.5h17.258m.223-1.4h-17.7A1.151,1.151,0,0,0,408,499.229V510.65a1.151,1.151,0,0,0,1.177,1.125h3.463v3.069a.332.332,0,0,0,.342.325.34.34,0,0,0,.22-.079l3.667-3.315h10.012a1.151,1.151,0,0,0,1.177-1.125V499.229a1.151,1.151,0,0,0-1.177-1.125Z"
        transform="translate(-408.004 -498.104)"
      />
      <g transform="translate(5.059 2.854)">
        <rect width="6" height="1.4" />
      </g>
      <g transform="translate(5.059 5.854)">
        <rect width="10" height="1.4" />
      </g>
      <g transform="translate(5.059 8.854)">
        <rect width="10" height="1.4" />
      </g>
    </svg>
  );
};

const SettingBookIcon = (props: ICon) => {
  const { width = 14, height = 20, fill = '#fff' } = props;
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width={width} height={height} viewBox="0 0 32 32">
      <g transform="translate(-655.807 -524.88)">
        <rect
          width={width}
          height={height}
          fill={fill}
          transform="translate(655.807 524.88)"
          opacity="0"
        />
        <path
          d="M669.139,534.751a3.462,3.462,0,1,1-3.461,3.461,3.465,3.465,0,0,1,3.461-3.461m0-1.868a5.329,5.329,0,1,0,5.329,5.329,5.33,5.33,0,0,0-5.329-5.329Z"
          transform="translate(2.668 2.668)"
        />
        <path
          d="M672.9,528.748v2.015l.032,1.287,1.187.464c.125.049.251.1.372.152l1.173.524.909-.909L678,530.859l2.5,2.5-1.421,1.421-.908.907.521,1.172c.059.132.111.265.163.4l.461,1.195h3.3v3.528h-3.3l-.461,1.195c-.052.135-.1.268-.163.4l-.521,1.172.908.908,1.421,1.421-2.5,2.495-1.421-1.421-.905-.905-1.172.517c-.133.06-.272.113-.409.168l-1.187.464v3.289h-3.528v-3.291l-1.189-.464c-.137-.053-.275-.107-.408-.167l-1.171-.517-.905.905-1.423,1.421-2.495-2.495,1.421-1.421.9-.9-.516-1.169c-.057-.132-.109-.267-.161-.4l-.459-1.2h-3.3v-3.528h3.3l.459-1.2c.052-.133.1-.267.161-.4l.516-1.169-.9-.9-1.421-1.421,2.495-2.5,1.423,1.421.908.909,1.175-.524c.124-.056.253-.105.4-.163l1.189-.464v-3.291H672.9m1.868-1.868h-7.264v3.883c-.164.064-.327.127-.485.2l-2.743-2.743-5.136,5.137,2.741,2.741c-.069.16-.133.323-.2.485h-3.883v7.264h3.883c.063.163.127.327.2.485l-2.741,2.743,5.136,5.136,2.743-2.743c.159.071.321.135.485.2v3.881h7.264v-3.881c.163-.064.325-.128.484-.2L678,552.209l5.137-5.136-2.743-2.743c.071-.159.135-.323.2-.485h3.881v-7.264h-3.881c-.064-.163-.128-.325-.2-.485l2.743-2.741L678,528.217l-2.743,2.743c-.159-.071-.321-.133-.484-.2V526.88Z"
          transform="translate(0.667 0.667)"
        />
      </g>
    </svg>
  );
};

const FilterMenuIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#D42A1C' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.75 16.125h-9m16.5 0h-4.5m-9-8.25h-3m16.5 0H9.75m0-2.25v4.5m6 8.25v-4.5"
        stroke={fill}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const HomeIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#303030' } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 19 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.75 17.7494V13.2461C11.75 13.047 11.671 12.8561 11.5303 12.7153C11.3897 12.5746 11.1989 12.4955 11 12.4955H8C7.80109 12.4955 7.61032 12.5746 7.46967 12.7153C7.32902 12.8561 7.25 13.047 7.25 13.2461V17.7494C7.25 17.9485 7.17098 18.1394 7.03033 18.2802C6.88968 18.4209 6.69891 18.5 6.5 18.5H2C1.80109 18.5 1.61032 18.4209 1.46967 18.2802C1.32902 18.1394 1.25 17.9485 1.25 17.7494V9.07106C1.25168 8.96719 1.27411 8.8647 1.31597 8.76964C1.35783 8.67457 1.41828 8.58885 1.49375 8.51752L8.99375 1.69678C9.13201 1.5702 9.31261 1.5 9.5 1.5C9.68739 1.5 9.86799 1.5702 10.0062 1.69678L17.5062 8.51752C17.5817 8.58885 17.6422 8.67457 17.684 8.76964C17.7259 8.8647 17.7483 8.96719 17.75 9.07106V17.7494C17.75 17.9485 17.671 18.1394 17.5303 18.2802C17.3897 18.4209 17.1989 18.5 17 18.5H12.5C12.3011 18.5 12.1103 18.4209 11.9697 18.2802C11.829 18.1394 11.75 17.9485 11.75 17.7494Z"
        stroke={fill}
        strokeWidth={2}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const CloseIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#303030', className, onClick } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
      className={className}
    >
      <path
        d="M18 6 6 18M6 6l12 12"
        stroke={fill}
        strokeWidth={1.5}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const SpeakerIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#303030', className, onClick } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 425.2 430"
      xmlSpace="preserve"
      {...props}
    >
      <g fill={fill}>
        <path d="M216.2.9c-5.9-2.2-12.5-.5-16.6 4.3L104.1 116H0v198h104.1l95.5 110.8c2.9 3.4 7.1 5.2 11.4 5.2 1.7 0 3.5-.3 5.2-.9 5.9-2.2 9.8-7.8 9.8-14.1V15c0-6.3-3.9-11.9-9.8-14.1zM30 146h66v138H30V146zm165 228.6-69-81.2V136.6l69-81.2v319.2zm65.1 10.5c-8.3 0-15.1-6.8-15.1-15.1s6.8-15.1 15.1-15.1c74.4 0 134.9-60.5 134.9-134.9S334.5 85.1 260.1 85.1c-8.3 0-15.1-6.8-15.1-15.1s6.8-15.1 15.1-15.1c91 0 165.1 74.1 165.1 165.1s-74.1 165.1-165.1 165.1z" />
        <path d="M268.1 322c-8.3 0-15-6.7-15-15s6.7-15 15-15c35.8 0 65-29.2 65-65v-14c0-35.8-29.2-65-65-65-8.3 0-15-6.7-15-15s6.7-15 15-15c52.4 0 95 42.6 95 95v14c0 52.4-42.6 95-95 95z" />
      </g>
    </svg>
  );
};

const PlayVoiceIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#303030', className, onClick } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 48 48"
      {...props}
    >
      <g transform="translate(-628.874 -272.572)">
        <circle cx={24} cy={24} r={24} transform="translate(628.874 272.572)" fill="#fc9801" />
        <path
          d="m665.726 295.533-19.015-10.98a1.2 1.2 0 0 0-1.8 1.039v21.958a1.2 1.2 0 0 0 1.8 1.039l19.015-10.978a1.2 1.2 0 0 0 0-2.078Z"
          fill="#fff"
        />
      </g>
    </svg>
  );
};

const StopSpeakIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#9c0e0e', className, onClick } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill={fill}
      onClick={onClick}
      viewBox="0 0 512 512"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        shapeRendering="geometricPrecision"
        d="M504 256C504 119 393 8 256 8S8 119 8 256s111 248 248 248 248-111 248-248zm-448 0c0-110.5 89.5-200 200-200s200 89.5 200 200-89.5 200-200 200S56 366.5 56 256zm296-80v160c0 8.8-7.2 16-16 16H176c-8.8 0-16-7.2-16-16V176c0-8.8 7.2-16 16-16h160c8.8 0 16 7.2 16 16z"
      />
    </svg>
  );
};

const ResumeSpeakIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#6f5f30', className, onClick } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path fill="none" stroke={fill} strokeWidth={2} d="M1 20h5V4H1v16Zm10-1 11-7-11-7v14Z" />
    </svg>
  );
};

const PauseSpeakIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#502244', className, onClick } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      fill={fill}
      onClick={onClick}
      viewBox="0 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path d="M12 6h-2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Zm10 0h-2a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h2a2 2 0 0 0 2-2V8a2 2 0 0 0-2-2Z" />
      <path fill="none" d="M0 0h32v32H0z" />
    </svg>
  );
};

const SettingSpeakIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#41416d', className, onClick } = props;
  return (
    <svg
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        data-name="settings-Filled"
        d="M20.33 9.78h-.03a1.207 1.207 0 0 1-1.11-.75.01.01 0 0 0-.01-.01 1.218 1.218 0 0 1 .26-1.31l.03-.03a1.672 1.672 0 0 0 0-2.36l-.79-.78a1.672 1.672 0 0 0-2.36 0l-.01.02a1.233 1.233 0 0 1-1.33.25 1.192 1.192 0 0 1-.76-1.11v-.03A1.664 1.664 0 0 0 12.56 2h-1.12a1.664 1.664 0 0 0-1.66 1.67v.03a1.2 1.2 0 0 1-.75 1.11 1.149 1.149 0 0 1-.48.1 1.2 1.2 0 0 1-.85-.35l-.02-.02a1.672 1.672 0 0 0-2.36 0l-.79.78a1.672 1.672 0 0 0 0 2.36l.03.03a1.217 1.217 0 0 1-.86 2.07h-.03A1.673 1.673 0 0 0 2 11.45v1.11a1.673 1.673 0 0 0 1.67 1.67h.03a1.182 1.182 0 0 1 1.11.75 1.248 1.248 0 0 1-.25 1.33l-.02.01a1.684 1.684 0 0 0 0 2.37l.78.78a1.672 1.672 0 0 0 2.36 0l.02-.02a1.186 1.186 0 0 1 1.31-.26 1.214 1.214 0 0 1 .77 1.12v.03A1.656 1.656 0 0 0 11.44 22h1.12a1.656 1.656 0 0 0 1.66-1.66v-.03a1.214 1.214 0 0 1 .77-1.12 1.186 1.186 0 0 1 1.31.26l.02.02a1.672 1.672 0 0 0 2.36 0l.78-.78a1.684 1.684 0 0 0 0-2.37l-.02-.01a1.248 1.248 0 0 1-.25-1.33 1.182 1.182 0 0 1 1.11-.75h.03A1.673 1.673 0 0 0 22 12.56v-1.11a1.673 1.673 0 0 0-1.67-1.67ZM12 15.5a3.5 3.5 0 1 1 3.5-3.5 3.5 3.5 0 0 1-3.5 3.5Z"
        fill={fill}
      />
    </svg>
  );
};

const BookFontIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#000', className, onClick } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      fill={fill}
      width={width}
      height={height}
      className={className}
      onClick={onClick}
      viewBox="0 0 24 24"
      {...props}
    >
      <path d="M22,20H20.684L13.932,2.638A1,1,0,0,0,13,2H11a1,1,0,0,0-.932.638L3.316,20H2a1,1,0,0,0,0,2H7a1,1,0,0,0,0-2H5.462l2.722-7h7.632l2.723,7H17a1,1,0,0,0,0,2h5a1,1,0,0,0,0-2ZM8.962,11l2.722-7h.632l2.722,7Z" />
    </svg>
  );
};

const CloseCircleIcon = (props: ICon) => {
  const { width = 24, height = 24, fill = '#000', className, onClick } = props;
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={className}
      viewBox="0 0 24 24"
      {...props}
    >
      <g fill="none" fillRule="evenodd">
        <path d="M0 0h24v24H0z" />
        <circle stroke={fill} strokeWidth={2} strokeLinecap="round" cx={12} cy={12} r={9} />
        <path
          stroke={fill}
          strokeWidth={2}
          strokeLinecap="round"
          d="m14.121 9.879-4.242 4.242m0-4.242 4.242 4.242"
        />
      </g>
    </svg>
  );
};

export {
  BookRequestIcon,
  HeartIcon,
  CartIcon,
  UserIcon,
  SubscriptionIcon,
  WishListIcon,
  FavoriteIcon,
  StarEmptyIcon,
  StarFullIcon,
  CartPurchaseIcon,
  StorePurchaseIcon,
  BookPurchaseIcon,
  AudioIcon,
  MyBookIcon,
  OrderIcon,
  ReviewIcon,
  SettingBookIcon,
  FilterMenuIcon,
  CloseIcon,
  HomeIcon,
  SpeakerIcon,
  PlayVoiceIcon,
  StopSpeakIcon,
  PauseSpeakIcon,
  ResumeSpeakIcon,
  SettingSpeakIcon,
  BookFontIcon,
  CloseCircleIcon,
  UserCircleIcon,
};
